var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 124,
    viewBox: "0 0 116 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8213 61.2935H61.0032C59.8589 61.2935 58.9292 60.3606 58.9292 59.2123V3.44893C58.9292 2.30065 59.8589 1.36768 61.0032 1.36768H86.8213C87.9656 1.36768 88.8953 2.30065 88.8953 3.44893V59.2123C88.8953 60.3606 87.9656 61.2935 86.8213 61.2935Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8965 20.6014V18.233C89.8965 17.7307 90.3256 17.3718 90.8262 17.3718L103.914 18.3048C104.415 18.3048 104.844 18.6636 104.844 19.166V21.5343C104.844 22.0367 104.415 22.3955 103.914 22.3955L90.8262 21.4626C90.3256 21.4626 89.8965 21.1037 89.8965 20.6014Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8965 42.634V45.0024C89.8965 45.5047 90.3256 45.8636 90.8262 45.8636L103.914 44.9306C104.415 44.9306 104.844 44.5718 104.844 44.0694V41.7011C104.844 41.1987 104.415 40.8398 103.914 40.8398L90.8262 41.7728C90.3256 41.7728 89.8965 42.1317 89.8965 42.634Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.912 33.5195V30.0029C101.912 26.271 103.342 21.1038 108.634 21.1038C112.353 21.1038 115.357 24.118 115.357 27.8499V36.1032C115.357 39.8351 112.353 42.8493 108.634 42.8493C104.272 42.7775 101.912 37.2514 101.912 33.5195Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.634 21.1038C111.423 21.965 113.426 24.6204 113.426 27.7064V36.1749C113.426 39.2609 111.423 41.9163 108.563 42.7775",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3984 21.5344C91.3984 21.5344 88.8953 21.678 88.8953 24.764",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3984 41.701C91.3984 41.701 88.8953 41.5574 88.8953 38.4714",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8213 123.081H61.0032C59.8589 123.081 58.9292 122.148 58.9292 120.999V65.236C58.9292 64.0878 59.8589 63.1548 61.0032 63.1548H86.8213C87.9656 63.1548 88.8953 64.0878 88.8953 65.236V120.999C88.8953 122.148 87.9656 123.081 86.8213 123.081Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8965 83.6802V81.3119C89.8965 80.8095 90.3256 80.4507 90.8262 80.4507L103.914 81.3837C104.415 81.3837 104.844 81.7425 104.844 82.2449V84.6132C104.844 85.1156 104.415 85.4744 103.914 85.4744L90.8262 84.5414C90.3256 84.5414 89.8965 84.1108 89.8965 83.6802Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8965 105.713V108.081C89.8965 108.584 90.3256 108.942 90.8262 108.942L103.914 108.009C104.415 108.009 104.844 107.651 104.844 107.148V104.78C104.844 104.278 104.415 103.919 103.914 103.919L90.8262 104.852C90.3256 104.852 89.8965 105.211 89.8965 105.713Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.912 96.5984V93.0818C101.912 89.3499 103.342 84.1826 108.634 84.1826C112.353 84.1826 115.357 87.1969 115.357 90.9288V99.1103C115.357 102.842 112.353 105.856 108.634 105.856C104.272 105.856 101.912 100.259 101.912 96.5984Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.634 84.1826C111.423 85.0438 113.426 87.6992 113.426 90.7852V99.2538C113.426 102.34 111.423 104.995 108.563 105.856",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3984 84.6133C91.3984 84.6133 88.8953 84.7568 88.8953 87.8428",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3984 104.78C91.3984 104.78 88.8953 104.636 88.8953 101.55",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0684 123.081H29.2503C28.106 123.081 27.1763 122.148 27.1763 120.999V65.236C27.1763 64.0878 28.106 63.1548 29.2503 63.1548H55.0684C56.2127 63.1548 57.1424 64.0878 57.1424 65.236V120.999C57.0709 122.148 56.2127 123.081 55.0684 123.081Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1751 105.713V108.081C26.1751 108.584 25.746 108.942 25.2453 108.942L12.1575 108.009C11.6569 108.009 11.2278 107.651 11.2278 107.148V104.78C11.2278 104.278 11.6569 103.919 12.1575 103.919L25.2453 104.852C25.746 104.852 26.1751 105.211 26.1751 105.713Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1751 83.6802V81.3119C26.1751 80.8095 25.746 80.4507 25.2453 80.4507L12.1575 81.3837C11.6569 81.3837 11.2278 81.7425 11.2278 82.2449V84.6132C11.2278 85.1156 11.6569 85.4744 12.1575 85.4744L25.2453 84.5414C25.746 84.5414 26.1751 84.1108 26.1751 83.6802Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0885 92.7946V96.3112C14.0885 100.043 12.6581 105.21 7.36578 105.21C3.64683 105.21 0.643066 102.196 0.643066 98.4643V90.211C0.643066 86.4791 3.64683 83.4648 7.36578 83.4648C11.7999 83.5366 14.0885 89.0627 14.0885 92.7946Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36569 105.21C4.57648 104.349 2.57397 101.694 2.57397 98.6078V90.1392C2.57397 87.0532 4.57648 84.3978 7.43721 83.5366",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6731 104.78C24.6731 104.78 27.1762 104.636 27.1762 101.55",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6731 84.5415C24.6731 84.5415 27.1762 84.685 27.1762 87.771",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0684 61.2935H29.2503C28.106 61.2935 27.1763 60.3606 27.1763 59.2123V3.44893C27.1763 2.30065 28.106 1.36768 29.2503 1.36768H55.0684C56.2127 1.36768 57.1424 2.30065 57.1424 3.44893V59.2123C57.0709 60.3606 56.2127 61.2935 55.0684 61.2935Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1751 42.634V45.0024C26.1751 45.5047 25.746 45.8636 25.2453 45.8636L12.1575 44.9306C11.6569 44.9306 11.2278 44.5718 11.2278 44.0694V41.7011C11.2278 41.1987 11.6569 40.8398 12.1575 40.8398L25.2453 41.7728C25.746 41.7728 26.1751 42.1317 26.1751 42.634Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1751 20.6014V18.233C26.1751 17.7307 25.746 17.3718 25.2453 17.3718L12.1575 18.3048C11.6569 18.3048 11.2278 18.6636 11.2278 19.166V21.5343C11.2278 22.0367 11.6569 22.3955 12.1575 22.3955L25.2453 21.4626C25.746 21.4626 26.1751 21.1037 26.1751 20.6014Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0885 29.7158V33.2324C14.0885 36.9643 12.6581 42.1315 7.36578 42.1315C3.64683 42.1315 0.643066 39.1173 0.643066 35.3854V27.2039C0.643066 23.472 3.64683 20.4578 7.36578 20.4578C11.7999 20.4578 14.0885 25.9839 14.0885 29.7158Z",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36569 42.1316C4.57648 41.2703 2.57397 38.615 2.57397 35.5289V27.1322C2.57397 24.0461 4.57648 21.3908 7.43721 20.5295",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6731 41.701C24.6731 41.701 27.1762 41.5574 27.1762 38.4714",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6731 21.5344C24.6731 21.5344 27.1762 21.678 27.1762 24.764",
    stroke: "#2C2E3E",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.220774b9.svg";
export { ForwardRef as ReactComponent };